import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Raza/getFiltrarRaza`, method: 'POST', body: values, token: token})
}
